module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("申请人")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("申请部门")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("申请日期")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  })]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "detail-page-title",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("申请信息")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("所属业务")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("盖章事由"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("报送单位"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("文件名称"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("份数")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("文件类型")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("拟用章")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  })])])]), _vm._v(" "), _c('x-table', {
    attrs: {
      "id": "seal-table"
    }
  }, [_c('tbody', [_c('tr', {
    staticClass: "seal-table-title"
  }, [_c('td', [_vm._v("类型")]), _vm._v(" "), _c('td', [_vm._v("拟用章")]), _vm._v(" "), _c('td', [_vm._v("持章人")])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')])])]), _vm._v(" "), _c('x-table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("盖章文件")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("盖章数量")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("是否业务盖章")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("备注")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("登记人")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("登记日期")]), _vm._v(" "), _c('td')])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c092c16","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/launch/attendance/sealApply.vue
// module id = C3OY
// module chunks = 1